 /**
   * bộ điều kiện
   * pqkhanh 17.05.2024
   */
export default {
  And: 0,
  Or: 1,
};
